"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.546 7.451L17.4 6.6v5.12l-5.853.046V7.451zm-.532.079l-4.414.6.004 3.669 4.411-.025-.001-4.244zm0 8.981l-.002-4.248-4.409-.028v3.671l4.412.605zm6.385.889l.001-5.097-5.862-.01.008 4.284 5.853.823z" }), "Window");
//# sourceMappingURL=Windows.js.map